import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  public PROXY_API = window.location.origin + '/proxy';

  constructor(private http: HttpClient) {
  }

  submitLicense(licenseKey: string) {

    const options = {
      params: new HttpParams()
        .set('licenseKey', licenseKey),
      // reportProgress: false,
      responseType: 'text' as 'json'
    };

    return this.http.get<string>(this.PROXY_API + '/license', options);
  }
}
